<template>
<a href="#" class="signinbutton w-inline-block" @click="$emit('login')">
  <div class="div-block-9"><img :src="logo" width="24" height="24" sizes="24px" class="image" style="border-radius: 16px;">
    <div class="text-block-3">{{ user ? 'Switch User' : 'Sign In' }}</div>
  </div>
</a>
</template>

<script>
import { db } from '../main'

export default {
  name: 'SignInButton',
  props: ['user'],
  data () {
    return {
      user_info: null,
      logo: '../../static/images/google-logo.png'
    }
  },
  watch: {
    user: function () {
      if (this.user !== null) {
        this.$bind('user_info', db.collection('user').doc(this.user.uid))
      }
    },
    user_info: function () {
      if (this.user_info) {
        this.logo = this.user_info.photo_url
      } else {
        this.logo = '../../static/images/google-logo.png'
      }
    }
  },
  mounted: function () {
    if (this.user !== null) {
      this.$bind('user_info', db.collection('user').doc(this.user.uid))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignInButton.vue